export const UnitProfilePaymentDetailsComponentTabsData = [
  { tab: 'payment-details' },
  { tab: 'custom-fields' },
];
